import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

// Bloque le zoom navigateur en mode kiosque : Ctrl + molette et
// Ctrl + '+'/'-'/'0' restent actifs même avec le flag --kiosk de Chrome.
window.addEventListener(
  'wheel',
  (event: WheelEvent) => {
    if (event.ctrlKey) {
      event.preventDefault();
    }
  },
  { passive: false },
);

window.addEventListener('keydown', (event: KeyboardEvent) => {
  if ((event.ctrlKey || event.metaKey) && ['+', '-', '=', '0'].includes(event.key)) {
    event.preventDefault();
  }
});

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
